// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"6451bea7","372":"60fcc034","529":"db4d1375","766":"d07b548c"}[chunkId] + ".js";
};